const FilterCheckbox = ({
  id,
  label,
  type,
  field,
  handleFilter,
  selectedCheckboxes = [],
}) => {
  const isChecked = selectedCheckboxes.includes(id);
  const handleChange = (e) => {
    handleFilter(type, field, e);
  };
  return (
    <li>
      <input
        type="checkbox"
        id={id}
        checked={isChecked}
        onChange={handleChange}
      />
      <span>{label}</span>
    </li>
  );
};
export default FilterCheckbox;
